import Metadata from '@/core/components/metadata/Metadata.tsx'
import NotificationContainer from '@/modules/utilities/notification/containers/NotificationContainer.tsx'

const NotificationsPage = () => {
  return (
    <>
      <Metadata>
        <title>Notificaciones</title>
      </Metadata>
      <NotificationContainer />
    </>
  )
}

export default NotificationsPage
